export default "https://cdn.questicon.mathletics.com/assets/images/summary-mountain-9f86a890d40f06447eba78ddd81f2281.svg";